// extracted by mini-css-extract-plugin
export default {"page":"Teachers_page__xi9ay","container":"Teachers_container__617NL","header":"Teachers_header__HZfVT","bar":"Teachers_bar__n+T2o","table":"Teachers_table__wwLUA"};